import { IApplicationState } from '../../types/redux';

export type TTrackingUserAuthorized = {
  userId: number | null;
  extra: {
    defaultRegionId: number;
  };
};

export type TTrackingUser = TTrackingUserAuthorized | {};

export const getTrackingUser = (state: IApplicationState): TTrackingUser => {
  const { user } = state;

  if (user.isAuthenticated) {
    return {
      userId: user.userId,
    };
  }

  return {};
};
